import { FormControl, InputAdornment, InputLabel, Select } from "@mui/material";
import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const SelectInput = ({
  icon,
  children,
  placeholder,
  formStyleProps = {},
  ...props
}) => {
  const style = {
    "&.MuiFormControl-root .MuiInputLabel-root": {
      color:"primary.main",
      fontSize:"0.875rem",
    },
    "&.MuiFormControl-root .MuiOutlinedInput-root": {
      borderRadius: 1.5,
      fontSize:"0.875rem",
      color:"primary.main",
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #c1c1c1`,
        // boxShadow: "0px 0px 4px 0px #00000054",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #c1c1c1 !important`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #c1c1c1 !important`,
      },
      "& .MuiSvgIcon-root": {
        color: "primary.main",
      },
    },
  };

  const menuProps = {
    PaperProps: {
      style: {
        boxShadow: "0px 0px 4px 0px #00000054",
      },
    },
  };

  return (
    <FormControl fullWidth sx={{ ...style, ...formStyleProps }} 
    size="small"
    
    >
      <InputLabel id="demo-select-small-label">{placeholder}</InputLabel>
      <Select
        startAdornment={
          icon && <InputAdornment position="start">{icon}</InputAdornment>
        }
        variant="outlined"
        labelId="demo-select-small-label"
        id="demo-select-small"
        label={placeholder}
        MenuProps={menuProps}
        {...props}
        IconComponent={ExpandMoreIcon}
      >
        {children}
      </Select>
    </FormControl>
  );
};

export default SelectInput;
